import { render, staticRenderFns } from "./TagsBrowse.vue?vue&type=template&id=6e094586&scoped=true"
import script from "./TagsBrowse.vue?vue&type=script&lang=js"
export * from "./TagsBrowse.vue?vue&type=script&lang=js"
import style0 from "./TagsBrowse.vue?vue&type=style&index=0&id=6e094586&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e094586",
  null
  
)

export default component.exports